import { first } from 'rxjs/operators';
import { JobService, Job } from '@app/_components/job';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JobComponent } from '../job/job.component';
import { Component, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-job-list',
    templateUrl: './job-list.component.html',
    styleUrls: ['./job-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class JobListComponent implements OnInit {
    jobCategories: any;
    jobLevels: any;
    locationCategories: any;
    states: any[];
	constructor(
		private constantService: ConstantService,
		private jobService: JobService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.jobCategories = jobService.jobCategories;
		this.jobLevels = jobService.jobLevels;
		this.locationCategories = jobService.locationCategories;
		this.states =  this.constantService.states;
		this.statuses = jobService.statuses;
	}



	// data
	jobs: any;
	job: Job;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'jobId', header: 'Id', width: 'auto' }, 
		{ field: 'jobCategory', header: 'Job Category', width: 'auto' },
		{ field: 'jobLevel', header: 'Job Level', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'jobTitle', header: 'Job Title', width: 'auto' },
		{ field: 'salaryRange', header: 'Salary Range', width: 'auto' },
		{ field: 'locationId', header: 'Location Name', width: 'auto' },
		{ field: 'adrCity', header: 'Address City', width: 'auto' },
		{ field: 'adrState', header: 'Adrress State', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.jobId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-job-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.jobService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.jobs = res.data.jobs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.jobs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(job: Job) {
		try {
			this.formLoading = true;
			this.jobService.update(job)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.jobs.map((job, i) => {
							if (job.jobId === res.data.job.jobId) {
								this.jobs[i] = res.data.job;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(job: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(job));

			this.formLoading = true;
			this.jobService.delete(job.jobId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.jobs.splice(this.jobs.indexOf(job), 1);
						this.recordTotal = this.jobs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Job ' + job.jobId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Job ' + job.jobId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Job'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(JobComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addJobCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(job: Job) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			job: job,
			title: 'Edit Job'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(JobComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateJobCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteJobCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addJobCB(job: Job) {
		console.log('Adding Job: ' + JSON.stringify(job));
		// if we don't have a jobs array yet...
		if (!this.jobs) {
			this.jobs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.jobs.unshift(job);

		// no idea what this is but it is required to update the array
		this.jobs = [...this.jobs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Job ' + job.jobId + ' Added', life: 3000 });
	}

	updateJobCB(job: Job) {
		console.log('Updating Job: ' + JSON.stringify(job));
		let itemIndex = this.jobs.findIndex((item: any) => item.jobId === job.jobId);
		this.jobs[itemIndex] = job;

		// no idea what this is but it is required to update the array
		this.jobs = [...this.jobs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Job ' + job.jobId + ' Updated', life: 3000 });
	}

	deleteJobCB(job: Job) {
		console.log('Removing Job: ' + job);
		this.jobs.splice(this.jobs.indexOf(job), 1);
		this.recordTotal = this.jobs.length;

		// no idea what this is but it is required to update the array
		this.jobs = [...this.jobs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Job ' + job.jobId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.jobs ? this.first === (this.jobs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.jobs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getJobCategoryName(job: any) {
		if (job?.jobCategory) {
			const status = this.jobCategories.find((e: any) => e.value == job.jobCategory);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getJobLevelName(job: any) {
		if (job?.jobLevel) {
			const status = this.jobLevels.find((e: any) => e.value == job.jobLevel);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getLocationCategoryName(job: any) {
		if (job?.locationId) {
			const locationName = this.locationCategories.find((e: any) => e.value == job.locationId);
			return locationName.name;
		}
		else {
			return '';
		}
	}
	
	getStateName(job: any) {
		if (job?.adrState) {
			const state = this.states.find((e: any) => e.abbr == job.adrState);
			return state.name;
		}
		else {
			return '';
		}
	}
	
	getStatusName(job: any) {
		if (job?.status) {
			const status = this.statuses.find((e: any) => e.value == job.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
